import { render } from "./LightDarkSwtichBtn.vue?vue&type=template&id=1b553c79&ts=true"
import script from "./LightDarkSwtichBtn.vue?vue&type=script&lang=ts"
export * from "./LightDarkSwtichBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__